import { HomeServices,getMentorData1 ,getStartupData1} from './service';

import {
    GET_A_MENTOR_DATA,GET_SINGLE_MENTOR_DATA,
    VIEW_STARTUP_APPLICATION_DATA
} from '../../common/constants/actionConstants';

import { isLoading } from '../../common/dependencies/action/action';

 export const getMentorData = (params) => dispatch => {
    
    dispatch(isLoading(true))
    return getBindData(params).then((data) => {
        const { currentInterventionList} = data;
        if (currentInterventionList) {
            dispatch({
                type:GET_A_MENTOR_DATA ,
                payload: currentInterventionList
            })
        }
        dispatch(isLoading(false))
    })
}

export const getMentorListData = (params) => dispatch => {
    dispatch(isLoading(true))
    return getBindData(params).then((data) => {
        const { mentorListData} = data;
        if (mentorListData) {
            dispatch({
                type:GET_SINGLE_MENTOR_DATA ,
                payload: mentorListData
            })
        }
        dispatch(isLoading(false))
    })
    
}
export const getStartupListData = (params) => dispatch => {
    dispatch(isLoading(true))
    return getBindData(params).then((data) => {
        const { startupListData} = data;
        if (startupListData) {
            dispatch({
                type:VIEW_STARTUP_APPLICATION_DATA ,
                payload: startupListData
            })
        }
        dispatch(isLoading(false))
    })
    
}

async function getBindData(params) {
    const currentInterventionList = await HomeServices.currentInervention(params).catch(e => { return { data: [], status: false } });
    const mentorListData = await getMentorData1.mentorListData(params).catch(e => { return { data: [], status: false } });
    const startupListData = await getStartupData1.startupData(params).catch(e => { return { data: [], status: false } });
   
    return { currentInterventionList,mentorListData ,startupListData}
}